import httpsService from "src/api/httpsService";
import { API_PATH } from "../const/api-urls";
import { IResponseInquiryBill } from "../interface/inquiryBill/responseInquiryBill";
import { IRequestInquiryBill } from "../interface/inquiryBill/requestInquiryBill";
import { BaseResponse } from "../interface/index";
import DateFns from 'src/utils/DateFns';
import { createCreDtTm, createMSGID } from "src/utils/helper";
import { DatePattend } from "src/utils/DatePattend";
import { FR_HEADER, TO_HEADER } from "src/const/const-from-env";
import { DefaultHeaderFrSystm, DefaultHeaderToSystm } from "src/const";
interface BodyI {
  insuranceContractNumber: string;
  bornPeopleBuyInsurance: string;
  bornPeopleUseInsurance: string;
  inquiryItemId?: string;
}

export const QueryInquiryBill = (body:BodyI,tokenCaptcha:string, frSystm?: string) => {
  const phDoB =  DateFns.formatDateTime(new Date(body.bornPeopleBuyInsurance),DatePattend.YearMonthDay)
  const laDoB =  DateFns.formatDateTime(new Date(body.bornPeopleUseInsurance),DatePattend.YearMonthDay)
  const convertPhDoB = phDoB.replaceAll("/","-")
  const convertLhDoB = laDoB.replaceAll("/","-")
  const convertBody = {
    idNumber: body.insuranceContractNumber,
    phDoB: convertPhDoB,
    laDoB: convertLhDoB,
    inquiryItemId: body?.inquiryItemId,
  };

  const param = { msgId: createMSGID(FR_HEADER) };
  const header = {
    frSystm: frSystm ? frSystm : DefaultHeaderFrSystm,
    toSystm: DefaultHeaderToSystm,
    creDtTm: createCreDtTm(),
    tokenCaptcha:tokenCaptcha
  };
  return httpsService.post<
    IRequestInquiryBill,
    BaseResponse<IResponseInquiryBill>
  >(API_PATH.INQUIRY_BILL, convertBody, { headers: header, params: param });
};
